import { DragDropModule } from '@angular/cdk/drag-drop';
import { LayoutModule } from '@angular/cdk/layout';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import {
  MatCommonModule,
  MatLineModule,
  MatNativeDateModule,
  MatPseudoCheckboxModule,
  MatRippleModule,
  NativeDateModule,
} from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacyChipsModule as MatChipsModule } from '@angular/material/legacy-chips';
import { MatLegacyOptionModule as MatOptionModule } from '@angular/material/legacy-core';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyListModule as MatListModule } from '@angular/material/legacy-list';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacyPaginatorModule as MatPaginatorModule } from '@angular/material/legacy-paginator';
import { MatLegacyProgressBarModule as MatProgressBarModule } from '@angular/material/legacy-progress-bar';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacySlideToggleModule as MatSlideToggleModule } from '@angular/material/legacy-slide-toggle';
import { MatLegacySliderModule as MatSliderModule } from '@angular/material/legacy-slider';
import { MatLegacySnackBarModule as MatSnackBarModule } from '@angular/material/legacy-snack-bar';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatLegacyTabsModule as MatTabsModule } from '@angular/material/legacy-tabs';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RouterModule } from '@angular/router';
import { TypedReactiveFormsModule } from '@gmrappdev/formsafe';
import { ValidationStateClassDirective } from 'src/app/shared/shared-base/amg-ui/directives/validation-state.directive';
import { LoggingModule } from 'src/app/shared/shared-base/amg-ui/logging/logging/logging.module';
import { ModuleWithProvidersStrict } from 'src/util/angular/ng-core';
import { AutocompleteComponent } from './components/autocomplete/autocomplete.component';
import { HumanizeModule } from './humanize/humanize.module';
import { MessageBoxModule } from './message-box/message-box.module';
import { AmgYesNoPipeModule } from './yesno/yes-no.module';
import { DateTimeInputModule } from './date-time-input/date-time-input.module';

export const materialModules = [
  MatListModule,
  MatNativeDateModule,
  MatButtonModule,
  MatAutocompleteModule,
  MatCardModule,
  MatCommonModule,
  MatSelectModule,
  MatSnackBarModule,
  MatSidenavModule,
  MatFormFieldModule,
  MatSliderModule,
  MatSlideToggleModule,
  MatButtonToggleModule,
  MatCheckboxModule,
  MatChipsModule,
  MatDatepickerModule,
  MatDialogModule,
  MatExpansionModule,
  MatIconModule,
  MatInputModule,
  MatLineModule,
  MatPaginatorModule,
  MatOptionModule,
  MatMenuModule,
  MatProgressBarModule,
  MatProgressSpinnerModule,
  MatPseudoCheckboxModule,
  MatRadioModule,
  MatRippleModule,
  MatSortModule,
  MatStepperModule,
  MatTableModule,
  MatTabsModule,
  MatToolbarModule,
  MatTooltipModule,
  NativeDateModule,
  LayoutModule,
  DragDropModule,
];

const imports = [
  ...materialModules,
  CommonModule,
  RouterModule,
  TypedReactiveFormsModule,
  FlexLayoutModule,
  MessageBoxModule,
  LoggingModule,
  HumanizeModule,
  AmgYesNoPipeModule,
  DateTimeInputModule,
];
const exportedDeclarations: any = [AutocompleteComponent, ValidationStateClassDirective];

@NgModule({
  imports: [imports],
  declarations: [...exportedDeclarations],
  exports: [...exportedDeclarations, ...imports],
})
export class AmgUiModule {
  public static forRoot(): ModuleWithProvidersStrict {
    return {
      ngModule: AmgUiModule,
      providers: [...LoggingModule.forRoot().providers],
    };
  }
}
